/**
 * HTML escaping for the two places the app builds raw HTML documents and
 * hands them to `document.write()` / a Blob download:
 *
 *   - printLyrics()          — interpolates song.title and song.lyrics
 *   - buildCertificateHtml() — interpolates customerName, email, licenseNumber
 *
 * Both previously interpolated values verbatim. Today that is self-XSS
 * (the user is the only one who can supply the strings), but it becomes a
 * real injection hole the moment any of this data arrives from a server or
 * from another user — which is exactly what Phase 3 introduces. Escaping
 * now means the sink is already safe when the untrusted source appears.
 */

const HTML_ENTITIES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

/**
 * Escapes a value for interpolation into HTML text content or a quoted
 * attribute value.
 *
 * @param value - Coerced to string; null/undefined become "".
 */
export function escapeHtml(value: unknown): string {
  if (value === null || value === undefined) return '';
  return String(value).replace(/[&<>"']/g, (ch) => HTML_ENTITIES[ch]);
}

/**
 * Escapes a value and converts newlines to <br />, for multi-line text
 * such as lyrics. Escaping happens first, so the inserted markup cannot
 * be produced by the input itself.
 *
 */
export function escapeHtmlWithBreaks(value: unknown): string {
  return escapeHtml(value).replace(/\r\n|\r|\n/g, '<br />');
}
